/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

import config from './config';
import { defaultItem, menu } from './menu';
import routes from './routes';
import scopes from './scopes';

const api = {
  auth: 'https://auth.cpl.cloud',
  url: `${process.env.REACT_APP_API_URL}/api/v1`,
};

export { defaultItem, menu, scopes, routes, config, api };
